/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { hash } from '@linc-technologies/linced-common/utils/promise';
import PersonType from '@linc-technologies/linced-common/enums/person-type';

export default class AllRoute extends Route {
  // Services
  @service
  store;

  model() {
    return hash({
      batches: this.store.findAll('medical/batch'),
      medications: this.store.findAll('medical/medication'),
      learners: this.store.query('person', { type: PersonType.LEARNER }),
      logs: this.store.findAll('medical/log'),
      schedules: this.store.findAll('medical/schedule'),
    });
  }
}
